import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import Phone, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';

const GeneralInfo = observer(class GeneralInfo extends React.Component {
  render() {
    const { translation } = this.props;

    return (
      <form className="panel" onSubmit={(e) => this.props.checkValidity(e, (e) => {this.props.handleSubmit(e)})} noValidate>
        <div className="panel__header">
          <h3 className="panel__title"><legend>{translation.heading}</legend></h3>
        </div>

        <fieldset className="panel__body">
          <ul className="fields">
            <li className="field--half">
              <label className="lbl-required" htmlFor="register-fname">{translation.fname}</label>
              <input type="text"
                id="register-fname"
                defaultValue={this.props.accountData.firstName}
                onChange={e => this.props.handleInput(e, 'firstName')}
                placeholder={translation.fname}
                required aria-required="true" autoFocus />
            </li>
            <li className="field--half">
              <label className="lbl-required" htmlFor="register-lname">{translation.lname}</label>
              <input type="text"
                id="register-lname"
                defaultValue={this.props.accountData.lastName}
                onChange={e => this.props.handleInput(e, 'lastName')}
                placeholder={translation.lname}
                required aria-required="true" />
            </li>
            <li>
              <label className="lbl-required" htmlFor="register-account-name">{translation.account_name}</label>
              <input type="text"
                id="register-account-name"
                defaultValue={this.props.accountData.accountName}
                onChange={e => this.props.handleInput(e, 'accountName')}
                placeholder={translation.account_name}
                required
                aria-required="true"
              />
            </li>
            <li>
              <label className="lbl-required" htmlFor="register-email">{translation.email}</label>
              <input type="email"
                id="register-email"
                defaultValue={this.props.accountData.email}
                onChange={e => this.props.handleInput(e, 'email')}
                placeholder={translation.email}
                required aria-required="true" />
            </li>
            <li>
              <label className="lbl-required" htmlFor="register-phone">{translation.phone.label}</label>
              <Phone
                id="register-phone"
                nativeExpanded={true}
                flagsPath="./static/img/flags/"
                country={parsePhoneNumber(this.props.accountData.phoneNumber).country || 'US'}
                value={this.props.accountData.phoneNumber}
                onChange={e => this.props.handleInput(e, 'phoneNumber')}
                required
                aria-required="true"
                aria-invalid={!isValidPhoneNumber(this.props.accountData.phoneNumber)}
              />
            </li>
            <li>
              <label className="lbl-required" htmlFor="register-account-description">{translation.description}</label>
              <input
                type="text"
                id="register-account-description"
                defaultValue={this.props.accountData.description}
                onChange={e => this.props.handleInput(e, 'description')}
                placeholder={translation.description}
                required
                aria-required="true"
              />
            </li>
          </ul>

          <div className="panel__actions actions">
            <button className="actions__btn actions__btn--primary" type="submit">{translation.button}</button>
          </div>
        </fieldset>
      </form>
    )
  }
})

export default translate('GeneralInfo')(GeneralInfo);


// WEBPACK FOOTER //
// ./src/app/components/Register/GeneralInfo.js